import { FIELDS } from './constants';

const defaultFields = [
  /*{
    field: 'commands',
    title: ' ',
    cell: 'commands',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 40,
  },
  {
    field: 'selectcommands',
    title: ' ',
    cell: 'selectcommands',
    headerCell: 'selectCommandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },*/
  {
     key: 'id',
     field: FIELDS.ID,
     title: 'Id',
     label: 'Id',
     cell: 'navigation',
     sortable: true,
     hidden: false,
     width: 75,
  },{
     key: 'name',
     field: FIELDS.NAME,
     title: 'Company',
     label: 'Company',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'contactFullName',
     field: FIELDS.CONTACT_FULL_NAME,
     title: 'Contact',
     label: 'Contact',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partNumber',
     field: FIELDS.PART_NUMBER,
     title: 'Part Number',
     label: 'Part Number',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'mfgName',
     field: FIELDS.MFG_NAME,
     title: 'Mfr',
     label: 'Mfr',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'nsnNumber',
     field: FIELDS.NSNNUMBER,
     title: 'NSN',
     label: 'NSN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'asPercent',
     field: FIELDS.AS_PERCENT,
     title: 'As Percent',
     label: 'As Percent',
     cell: 'checkMark',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'percentOfSale',
     field: FIELDS.PERCENT_OF_SALE,
     title: 'Comp. of Sale %',
     label: 'Comp. of Sale %',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'pricePerUnit',
     field: FIELDS.PRICE_PER_UNIT,
     title: 'Comp. $/Unit',
     label: 'Comp. $/Unit',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'harmonizedCode',
     field: FIELDS.HARMONIZED_CODE,
     title: 'HTS Code',
     label: 'HTS Code',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'scheduleB',
     field: FIELDS.SCHEDULE_B,
     title: 'Sched B',
     label: 'Sched B',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'eccn',
     field: FIELDS.ECCN,
     title: 'ECCN',
     label: 'ECCN',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'description',
     field: FIELDS.DESCRIPTION,
     title: 'Description',
     label: 'Description',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'categoryName',
     field: FIELDS.CATEGORY_NAME,
     title: 'Category',
     label: 'Category',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'className',
     field: FIELDS.CLASS_NAME,
     title: 'Class',
     label: 'Class',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'uom',
     field: FIELDS.UOM,
     title: 'UOM',
     label: 'UOM',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'package',
     field: FIELDS.PACKAGE,
     title: 'Item Pkg',
     label: 'Item Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'physPkg',
     field: FIELDS.PHYS_PKG,
     title: 'Phys Pkg',
     label: 'Phys Pkg',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'piecePerPkg',
     field: FIELDS.PIECE_PER_PKG,
     title: 'SPQ',
     label: 'SPQ',
     sortable: true,
     hidden: true,
     width: 150,
  },{
     key: 'leadFree',
     field: FIELDS.LEAD_FREE,
     title: 'RoHS',
     label: 'RoHS',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'partComments',
     field: FIELDS.PART_COMMENTS,
     title: 'Part Comments',
     label: 'Part Comments',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'createdByUserFullName',
     field: FIELDS.CREATED_BY_USER_FULL_NAME,
     title: 'Created By',
     label: 'Created By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'modifiedByUserFullName',
     field: FIELDS.MODIFIED_BY_USER_FULL_NAME,
     title: 'Modified By',
     label: 'Modified By',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateCreated',
     field: FIELDS.DATE_CREATED,
     title: 'Date Created',
     label: 'Date Created',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },{
     key: 'dateModified',
     field: FIELDS.DATE_MODIFIED,
     title: 'Date Modified',
     label: 'Date Modified',
     cell: 'formatDate',
     sortable: true,
     hidden: false,
     width: 150,
  },
  {
    field: 'deletecommands',
    title: ' ',
    cell: 'deletecommands',
    headerCell: 'commandsHeader',
    sortable: true,
    hidden: false,
    locked: true,
    width: 30,
  },
]

export default defaultFields;
